export default [{
	titulo: 'Concursos',
	icone: 'menu-icon fa fa-caret-right',
	url: '/servicos/concursos',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]